import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  tiktok_url: "https://www.tiktok.com/@everydayai_foryou",
  youtube_url: "https://www.youtube.com/channel/UC9VFDGd_jr_XvZrR4VZco8Q",
  tagline: "I stay on top of AI so you don't have to.",
  support_line: "Real builds. Plain English. No hype.",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = () =>
    api
      .get("/settings")
      .then(({ data }) => setSettings({ ...DEFAULTS, ...data }))
      .catch(() => {});

  useEffect(() => {
    refresh();
  }, []);

  return <SettingsContext.Provider value={{ settings, refresh }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
